import * as config from '@/config.json'
import axios from 'axios'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  name: 'DevicesEdit',
  components: {
    Loading
  },
  data() {
    return {
      isLoading: false,
      token: null,
      isAllowedDeviceEdit: false,
      newDevice: false,
      deviceId: null,
      deviceDescription: '',
      deviceType: '',
      deviceModel: '',
      deviceSerialNumber: '',
      deviceUrlBase: '',
      deviceResource: '',
      deviceUser: '',
      devicePassword: '',
      deviceEwelinkRegion: 'us',
      deviceExacqResponseVersion: '',
      deviceIsManualOpeningAllowed: false,
      deviceIsAllowedToMajorEighteen: false,
      deviceEwelinkAppId: 'Uw83EKZFxdif7XFXEsrpduz5YyjP7nTl',
      deviceEwelinkAppSecret: 'mXLOjea0woSMvK9gw7Fjsy7YlFO4iSu6',
      selectedOptionDeviceModel: null,
      devicesModels: [],
      optionDeviceModel: [],
      selectedOptionDeviceType: null,
      optionDeviceType: [],
      devicesTypes: [],
      siteId: null,
      companyId: null,
      homeAssistantToken:
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiI4ZmQ3ZDhmNjUzYWM0OTk1YTdkNWJjNTNhN2M2MTMwYSIsImlhdCI6MTc0MTgwNDM3OCwiZXhwIjoyMDU3MTY0Mzc4fQ.FtMK6eX6MWUJ0lFB4Zs8LK-76Jt5MK_Vq7Sc6J3dCYA',
      homeAssistantAppDaemonUrl: 'http://homeassistant.accesys.com.br:5050',
      homeAssistantEntityId: null,
      delayTime: null,
      showPassword: false,
      showDevicePassword: false
    }
  },
  methods: {
    focus(id) {
      try {
        const element = document.getElementById(id)
        if (element) {
          element.focus()
          if (element.tagName === 'SELECT') {
            element.click()
          }
          if (element.classList.contains('form-select')) {
            element.click()
          }
        }
      } catch (error) {
        console.error('Erro ao focar elemento:', error)
      }
    },

    showHomeAssistantToken() {
      const inputType = document.getElementById('homeAssistantToken').type
      if (inputType === 'password') {
        document.getElementById('homeAssistantToken').type = 'text'
        this.showPassword = true
      } else {
        document.getElementById('homeAssistantToken').type = 'password'
        this.showPassword = false
      }
      this.focus('homeAssistantToken')
    },

    showDevicePasswordToggle() {
      this.showDevicePassword = !this.showDevicePassword
      this.focus('devicePassword')
    },

    buildDataDevices() {
      const data = {}

      data.id = this.deviceId ? this.deviceId : null
      data.deviceTypeId = this.selectedOptionDeviceType ? parseInt(this.selectedOptionDeviceType) : null
      data.description = this.deviceDescription || ''
      data.serialNumber = this.deviceSerialNumber || ''
      data.urlBase = this.deviceUrlBase || ''
      data.resource = this.deviceResource || ''
      data.user = this.deviceUser || ''
      data.password = this.devicePassword || ''

      if (this.deviceExacqResponseVersion && this.deviceExacqResponseVersion !== '' && !isNaN(parseInt(this.deviceExacqResponseVersion))) {
        data.exacqResponseVersion = parseInt(this.deviceExacqResponseVersion)
      }

      if (this.deviceModel) {
        data.model = this.deviceModel
      } else {
        this.changeModel()
        data.model = this.deviceModel || ''
      }

      data.ewelinkRegion = this.deviceEwelinkRegion || 'us'
      data.isManualOpeningAllowed = this.deviceIsManualOpeningAllowed || false
      data.isAllowedToMajorEighteen = this.deviceIsAllowedToMajorEighteen || false
      data.ewelinkAppId = this.deviceEwelinkAppId || ''
      data.ewelinkAppSecret = this.deviceEwelinkAppSecret || ''

      data.deviceModelId = this.selectedOptionDeviceModel ? parseInt(this.selectedOptionDeviceModel) : null
      data.siteId = this.siteId ? parseInt(this.siteId) : null

      if (this.companyId && this.companyId !== null && this.companyId !== undefined && this.companyId !== '' && !isNaN(parseInt(this.companyId))) {
        data.companyId = parseInt(this.companyId)
      } else {
        data.companyId = null
      }

      if (this.deviceModel === 'HA_RELE' || this.deviceModel === 'HA_SENSOR') {
        data.homeAssistantToken = this.homeAssistantToken || ''
        data.homeAssistantAppDaemonUrl = this.homeAssistantAppDaemonUrl || ''
        data.homeAssistantEntityId =
          typeof this.homeAssistantEntityId === 'string' && this.homeAssistantEntityId.trim() !== '' ? this.homeAssistantEntityId.trim() : ''
        data.delayTime =
          this.delayTime !== null && this.delayTime !== undefined && this.delayTime !== '' && !isNaN(Number(this.delayTime))
            ? parseInt(this.delayTime)
            : 0
      } else {
        data.homeAssistantToken = ''
        data.homeAssistantAppDaemonUrl = ''
        data.homeAssistantEntityId = ''
        data.delayTime = 0
      }

      return data
    },

    validateDeviceData(data) {
      const errors = []

      if (!data.description || data.description.trim() === '') {
        errors.push('Descrição é obrigatória')
      }

      if (!data.deviceTypeId) {
        errors.push('Tipo do dispositivo é obrigatório')
      }

      if (!data.deviceModelId) {
        errors.push('Modelo do dispositivo é obrigatório')
      }

      if (data.model === 'EXACVISION') {
        if (!data.urlBase || data.urlBase.trim() === '') {
          errors.push('URL Base é obrigatória para dispositivos EXACVISION')
        }
        if (!data.resource || data.resource.trim() === '') {
          errors.push('Resource é obrigatório para dispositivos EXACVISION')
        }
      }

      if (data.model === 'HA_RELE' || data.model === 'HA_SENSOR') {
        if (!data.homeAssistantToken || data.homeAssistantToken.trim() === '') {
          errors.push('Home Assistant Token é obrigatório para dispositivos Home Assistant')
        }
        if (!data.homeAssistantAppDaemonUrl || data.homeAssistantAppDaemonUrl.trim() === '') {
          errors.push('Home Assistant App Daemon URL é obrigatória para dispositivos Home Assistant')
        }
        if (!data.homeAssistantEntityId || data.homeAssistantEntityId.trim() === '') {
          errors.push('Home Assistant Entity ID é obrigatório para dispositivos Home Assistant')
        }
      }

      return errors
    },

    async saveDevice() {
      try {
        this.isLoading = true
        const url = `${config.default.urlBase}/site/devices`
        const data = this.buildDataDevices()

        const validationErrors = this.validateDeviceData(data)
        if (validationErrors.length > 0) {
          await this.$alert(`Por favor, corrija os seguintes erros:\n${validationErrors.join('\n')}`, 'Erro de Validação', 'error')
          this.isLoading = false
          return
        }

        const response = await axios({
          url,
          method: 'POST',
          data,
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isLoading = false
          this.isAllowedDeviceEdit = false

          if (this.newDevice && response.data && response.data.id) {
            await this.$alert('Dispositivo criado com sucesso! Agora você pode vincular o dispositivo.', 'Sucesso', 'success')

            this.$router.push({
              name: 'DevicesList',
              params: {
                openLinkModal: 'true',
                deviceId: response.data.id,
                deviceDescription: response.data.description || this.deviceDescription
              }
            })
          } else {
            await this.$alert('Dados Atualizados com Sucesso!', 'Sucesso', 'success')
          }
        }

        if (response.status == 208) {
          await this.$alert(response.data.message, 'Aviso', 'warning')
        }
      } catch (error) {
        console.error('Erro ao salvar dispositivo:', error)
        this.isLoading = false

        if (error.response && error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        }
        if (error.response && (error.response.status == 400 || error.response.status == 404)) {
          await this.$alert(error.response.data.message, 'Aviso', 'warning')
        }

        if (error.response && error.response.status == 500) {
          await this.$alert(error.response.data.message, 'Erro', 'error')
        }
      }
    },

    async findDevicesTypes() {
      try {
        this.isLoading = true
        const url = `${config.default.urlBase}/devices/types`
        const response = await axios({
          url,
          method: 'GET',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })
        if (response.status == 200) {
          this.isLoading = false
          this.devicesTypes = response.data

          if (this.devicesTypes.length > 0) {
            this.optionDeviceType = await Promise.all(
              this.devicesTypes.map(item => {
                return {
                  value: item.id,
                  text: item.type
                }
              })
            )
          }
        }
      } catch (error) {
        console.error('Erro ao buscar tipos de dispositivos:', error)
        this.isLoading = false
        if (error.response && error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        }
        if (error.response && (error.response.status == 400 || error.response.status == 404)) {
          await this.$alert(error.response.data.message, 'Aviso', 'warning')
        }
        if (error.response && error.response.status == 500) {
          await this.$alert(error.response.data.message, 'Erro', 'error')
        }
      }
    },

    changeModel() {
      this.updateModelFromSelected()
    },

    async findDevicesModels() {
      try {
        this.isLoading = true
        const url = `${config.default.urlBase}/devices/models`
        const response = await axios({
          url,
          method: 'GET',
          headers: {
            authorization: `Bearer ${this.token}`
          }
        })

        if (response.status == 200) {
          this.isLoading = false
          this.devicesModels = response.data

          if (this.devicesModels.length > 0) {
            this.optionDeviceModel = await Promise.all(
              this.devicesModels.map(item => {
                return {
                  value: item.id,
                  text: item.description
                }
              })
            )
          }
        }
      } catch (error) {
        console.error('Erro ao buscar modelos de dispositivos:', error)
        this.isLoading = false
        if (error.response && error.response.status == 403) {
          await this.$alert('Sua sessão expirou. Faça o login novamente!', 'Aviso', 'warning')
          this.$router.push('login')
        }
        if (error.response && (error.response.status == 400 || error.response.status == 404)) {
          await this.$alert(error.response.data.message, 'Aviso', 'warning')
        }
        if (error.response && error.response.status == 500) {
          await this.$alert(error.response.data.message, 'Erro', 'error')
        }
      }
    },

    redirect(path) {
      this.$router.push(path)
    },

    selectDeviceModel(device) {
      this.optionDeviceModel.filter(item => {
        if (item.text == device) {
          this.selectedOptionDeviceModel = item.value
        }
      })
      this.updateModelFromSelected()
    },

    readLocalStorageDevices() {
      this.deviceId = localStorage.getItem('deviceId')
      this.deviceDescription = localStorage.getItem('deviceDescription')
      this.selectedOptionDeviceType = parseInt(localStorage.getItem('deviceTypeId'))
      this.deviceType = localStorage.getItem('deviceType')
      this.selectedOptionDeviceModel = parseInt(localStorage.getItem('deviceModelId'))
      this.deviceModel = localStorage.getItem('deviceModel')
      this.selectDeviceModel(this.deviceModel)
      this.deviceSerialNumber = localStorage.getItem('deviceSerialNumber')
      this.deviceUrlBase = localStorage.getItem('deviceUrlBase')
      this.deviceResource = localStorage.getItem('deviceResource')
      this.deviceUser = localStorage.getItem('deviceUser')
      this.devicePassword = localStorage.getItem('devicePassword')
      this.deviceEwelinkRegion = localStorage.getItem('deviceEwelinkRegion') ? localStorage.getItem('deviceEwelinkRegion') : 'us'
      this.deviceExacqResponseVersion = localStorage.getItem('deviceExacqResponseVersion')
        ? parseInt(localStorage.getItem('deviceExacqResponseVersion'))
        : null
      this.deviceIsManualOpeningAllowed = localStorage.getItem('deviceIsManualOpeningAllowed') == '1' ? true : false
      this.deviceIsAllowedToMajorEighteen = localStorage.getItem('deviceIsAllowedToMajorEighteen') == '1' ? true : false
      this.deviceEwelinkAppId = localStorage.getItem('deviceEwelinkAppId')
        ? localStorage.getItem('deviceEwelinkAppId')
        : 'Uw83EKZFxdif7XFXEsrpduz5YyjP7nTl'
      this.deviceEwelinkAppSecret = localStorage.getItem('deviceEwelinkAppSecret')
        ? localStorage.getItem('deviceEwelinkAppSecret')
        : 'mXLOjea0woSMvK9gw7Fjsy7YlFO4iSu6'

      this.homeAssistantToken =
        localStorage.getItem('homeAssistantToken') ||
        'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiI4ZmQ3ZDhmNjUzYWM0OTk1YTdkNWJjNTNhN2M2MTMwYSIsImlhdCI6MTc0MTgwNDM3OCwiZXhwIjoyMDU3MTY0Mzc4fQ.FtMK6eX6MWUJ0lFB4Zs8LK-76Jt5MK_Vq7Sc6J3dCYA'

      this.homeAssistantAppDaemonUrl = localStorage.getItem('homeAssistantAppDaemonUrl') || 'http://homeassistant.accesys.com.br:5050'

      this.homeAssistantEntityId = localStorage.getItem('homeAssistantEntityId') || ''

      const storedDelayTime = localStorage.getItem('delayTime')
      this.delayTime = storedDelayTime ? parseInt(storedDelayTime) : 0

      const storedCompanyId = localStorage.getItem('companyId')
      if (
        storedCompanyId &&
        storedCompanyId !== null &&
        storedCompanyId !== undefined &&
        storedCompanyId !== '' &&
        !isNaN(parseInt(storedCompanyId))
      ) {
        this.companyId = parseInt(storedCompanyId)
      } else {
        this.companyId = null
      }
    },

    getModel() {
      if (this.selectedOptionDeviceModel != null && this.optionDeviceModel.length > 0) {
        const selectedModel = this.optionDeviceModel.find(item => item.value === this.selectedOptionDeviceModel)
        return selectedModel ? selectedModel.text : null
      }
      return null
    },

    updateModelFromSelected() {
      if (this.selectedOptionDeviceModel && this.optionDeviceModel.length > 0) {
        const selectedModel = this.optionDeviceModel.find(item => item.value === this.selectedOptionDeviceModel)
        this.deviceModel = selectedModel ? selectedModel.text : ''

        if (this.deviceModel == 'SONOFF_PULSE' || this.deviceModel == 'SONOFF_DW2') {
          this.deviceEwelinkRegion = 'us'
          this.deviceEwelinkAppId = 'Uw83EKZFxdif7XFXEsrpduz5YyjP7nTl'
          this.deviceEwelinkAppSecret = 'mXLOjea0woSMvK9gw7Fjsy7YlFO4iSu6'
        }

        if (this.deviceModel == 'HA_RELE' || this.deviceModel == 'HA_SENSOR') {
          this.homeAssistantToken =
            'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiI4ZmQ3ZDhmNjUzYWM0OTk1YTdkNWJjNTNhN2M2MTMwYSIsImlhdCI6MTc0MTgwNDM3OCwiZXhwIjoyMDU3MTY0Mzc4fQ.FtMK6eX6MWUJ0lFB4Zs8LK-76Jt5MK_Vq7Sc6J3dCYA'
          this.homeAssistantAppDaemonUrl = 'http://homeassistant.accesys.com.br:5050'

          this.findHomeAssistantEntity()
        }
      }
    },

    async findHomeAssistantEntity() {
      try {
        if (
          !this.deviceSerialNumber ||
          this.deviceSerialNumber.trim() === '' ||
          (this.deviceModel !== 'HA_RELE' && this.deviceModel !== 'HA_SENSOR')
        ) {
          return
        }

        this.isLoading = true

        const url = `${config.default.urlBase}/devices/home-assistant/find-entity`
        const data = {
          serialNumber: this.deviceSerialNumber.trim(),
          homeAssistantToken: this.homeAssistantToken.trim(),
          homeAssistantAppDaemonUrl: this.homeAssistantAppDaemonUrl.trim()
        }

        console.log({
          data
        })

        const response = await axios({
          url,
          method: 'POST',
          data,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${this.token}`
          }
        })

        console.log({
          response
        })

        if (response.status === 200) {
          const entity_id = response.data.entity_id
          this.homeAssistantEntityId = entity_id
        }
      } catch (error) {
        console.error('Erro ao buscar entity_id do Home Assistant:', error)

        this.$alert(error.response.data.message, 'Erro', 'error')
      } finally {
        this.isLoading = false
      }
    },

    handleSwitchChange(field, value) {
      this[field] = value
    },

    showFieldHelp(fieldName) {
      const helpTexts = {
        deviceDescription:
          'Este campo é obrigatório e deve conter um descritivo para identificar o dispositivo. Recomendação: Use nomes claros e específicos para facilitar a identificação do dispositivo.',
        deviceModel:
          'Selecione o modelo do dispositivo que está sendo configurado. Esta informação é importante para determinar as configurações específicas necessárias. O modelo escolhido pode habilitar c ampos adicionais de configuração. Importante: Escolha o modelo correto para garantir a compatibilidade e funcionalidade adequada.',
        deviceSerialNumber:
          'Digite o número de série único do dispositivo. Este número é usado para identificação e comunicação com o equipamento. Para dispositivos Home Assistant, este campo é usado para buscar automaticamente a entidade correspondente. Dica: O número de série geralmente está impresso no dispositivo ou na embalagem.',
        deviceType:
          'Selecione o tipo de dispositivo baseado em sua função principal no sistema. Esta classificação ajuda a organizar e filtrar os dispositivos na listagem. Exemplos: Câmeras, Armários, Sensores, Assistentes.',
        deviceUser:
          'Digite o nome de usuário para autenticação no dispositivo, se necessário. Deixe em branco se o dispositivo não requer autenticação por usuário. Nota: Nem todos os dispositivos requerem autenticação por usuário.',
        devicePassword:
          'Digite a senha para autenticação no dispositivo, se necessário. Use o botão do olho para visualizar ou ocultar a senha digitada. Segurança: Mantenha as senhas em local seguro e use senhas fortes.',
        deviceExacqResponseVersion:
          'Digite a versão da resposta do sistema ExacqVision. Este campo é obrigatório apenas para dispositivos EXACVISION. Exemplo: 8, 9, 10 (valores numéricos inteiros)',
        deviceUrlBase:
          'Digite a URL base para comunicação com o dispositivo. Exemplos: "http://192.168.1.100", "https://meudispositivo.com", "http://192.168.0.50". Este campo é obrigatório para dispositivos EXACVISION. Formato: Inclua o protocolo (http:// ou https://) e o endereço IP ou domínio.',
        deviceResource:
          'Digite o recurso específico para comunicação com o dispositivo. Exemplos: "/api/v1/status", "/cgi-bin/userConfig.cgi", "/api/device/control". Este campo é obrigatório para dispositivos EXACVISION. Formato: Inicie sempre com barra (/) seguida do caminho da API.',
        deviceEwelinkRegion:
          'Digite a região do servidor Ewelink para dispositivos Sonoff. Opções disponíveis: us (Estados Unidos), eu (Europa), cn (China), as (Ásia). Padrão: us. Importante: Escolha a região mais próxima para melhor performance.',
        homeAssistantEntityId:
          'Este campo é preenchido automaticamente quando o número de série é inserido para dispositivos Home Assistant. Representa o identificador único da entidade no Home Assistant. Exemplo: switch.portao_principal, sensor.presenca_entrada. Nota: Se não for preenchido automaticamente, consulte a documentação do Home Assistant.',
        delayTime:
          'Digite o tempo de delay em milissegundos para dispositivos Home Assistant. Este valor determina quanto tempo aguardar entre comandos enviados ao dispositivo. Exemplos: 500 (meio segundo), 1000 (1 segundo), 2000 (2 segundos). Recomendação: Use valores entre 500 e 5000 milissegundos para a maioria dos dispositivos.',
        deviceIsManualOpeningAllowed:
          'Quando ativado, permite que o dispositivo seja aberto manualmente além dos controles automáticos do sistema. Útil para casos de emergência ou manutenção. Funcionalidade: Permite abertura física do dispositivo mesmo quando o sistema está operando normalmente. Recomendação: Ative apenas quando necessário para facilitar o acesso em situações especiais.',
        deviceIsAllowedToMajorEighteen:
          'Quando ativado, o dispositivo só permitirá acesso a pessoas maiores de 18 anos. O sistema verificará a idade cadastrada antes de autorizar o acesso. Uso: Ideal para áreas restritas, produtos controlados, ou ambientes que requerem maioridade. Importante: Certifique-se de que os usuários tenham a idade corretamente cadastrada no sistema.'
      }

      const helpText = helpTexts[fieldName] || 'Informações de ajuda não disponíveis para este campo.'

      this.$alert(helpText, 'Ajuda - ' + this.getFieldLabel(fieldName), 'info')
    },

    getFieldLabel(fieldName) {
      const labels = {
        deviceDescription: 'Descrição',
        deviceModel: 'Modelo',
        deviceSerialNumber: 'Número de Série',
        deviceType: 'Tipo',
        deviceUser: 'Usuário',
        devicePassword: 'Senha',
        deviceExacqResponseVersion: 'Versão de Resposta Exacq',
        deviceUrlBase: 'URL Base',
        deviceResource: 'Recurso',
        deviceEwelinkRegion: 'Região Ewelink',
        homeAssistantEntityId: 'ID da Entidade Home Assistant',
        delayTime: 'Tempo de Delay',
        deviceIsManualOpeningAllowed: 'Aceitar Abertura Manual',
        deviceIsAllowedToMajorEighteen: 'Acesso para Maiores de 18 anos'
      }
      return labels[fieldName] || fieldName
    },

    toggleEditMode() {
      if (this.isAllowedDeviceEdit) {
        this.saveDevice()
      } else {
        this.isAllowedDeviceEdit = true
      }
    },

    loadDeviceData() {
      if (!this.newDevice && this.deviceId) {
        try {
          if (!this.deviceId || isNaN(this.deviceId)) {
            throw new Error('ID do dispositivo inválido')
          }

          this.deviceId = this.$route.params.deviceId
          this.deviceDescription = this.$route.params.deviceDescription || ''
          this.selectedOptionDeviceType = this.$route.params.deviceTypeId ? parseInt(this.$route.params.deviceTypeId) : null
          this.deviceType = this.$route.params.deviceType || ''
          this.selectedOptionDeviceModel = this.$route.params.deviceModelId ? parseInt(this.$route.params.deviceModelId) : null
          this.deviceModel = this.$route.params.deviceModel || ''
          this.deviceSerialNumber = this.$route.params.deviceSerialNumber || ''
          this.deviceUrlBase = this.$route.params.deviceUrlBase || ''
          this.deviceResource = this.$route.params.deviceResource || ''
          this.deviceUser = this.$route.params.deviceUser || ''
          this.devicePassword = this.$route.params.devicePassword || ''
          this.deviceEwelinkRegion = this.$route.params.deviceEwelinkRegion || 'us'
          this.deviceExacqResponseVersion = this.$route.params.deviceExacqResponseVersion || ''
          this.deviceIsManualOpeningAllowed =
            this.$route.params.deviceIsManualOpeningAllowed === 'true' || this.$route.params.deviceIsManualOpeningAllowed === true
          this.deviceIsAllowedToMajorEighteen =
            this.$route.params.deviceIsAllowedToMajorEighteen === 'true' || this.$route.params.deviceIsAllowedToMajorEighteen === true
          this.deviceEwelinkAppId = this.$route.params.deviceEwelinkAppId || 'Uw83EKZFxdif7XFXEsrpduz5YyjP7nTl'
          this.deviceEwelinkAppSecret = this.$route.params.deviceEwelinkAppSecret || 'mXLOjea0woSMvK9gw7Fjsy7YlFO4iSu6'
          this.homeAssistantToken =
            this.$route.params.homeAssistantToken ||
            'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiI4ZmQ3ZDhmNjUzYWM0OTk1YTdkNWJjNTNhN2M2MTMwYSIsImlhdCI6MTc0MTgwNDM3OCwiZXhwIjoyMDU3MTY0Mzc4fQ.FtMK6eX6MWUJ0lFB4Zs8LK-76Jt5MK_Vq7Sc6J3dCYA'
          this.homeAssistantAppDaemonUrl = this.$route.params.homeAssistantAppDaemonUrl || 'http://homeassistant.accesys.com.br:5050'
          this.homeAssistantEntityId = this.$route.params.homeAssistantEntityId || ''
          this.delayTime = this.$route.params.delayTime ? parseInt(this.$route.params.delayTime) : 0
          this.deviceIsAllowedToMajorEighteen = this.$route.params.isAllowedToMajorEighteen === 1 ? true : false
          this.deviceIsManualOpeningAllowed = this.$route.params.isManualOpeningAllowed === 1 ? true : false

          if (
            this.$route.params.companyId &&
            this.$route.params.companyId !== null &&
            this.$route.params.companyId !== undefined &&
            this.$route.params.companyId !== '' &&
            !isNaN(parseInt(this.$route.params.companyId))
          ) {
            this.companyId = parseInt(this.$route.params.companyId)
          } else {
            this.companyId = null
          }

          this.$nextTick(() => {
            this.updateModelFromSelected()
          })
        } catch (error) {
          console.error('Erro ao carregar dados do dispositivo:', error)
          this.$alert(`Erro ao carregar dados do dispositivo: ${error.message}`, 'Erro', 'error')
        }
      }
    }
  },

  async beforeMount() {
    try {
      this.isLoading = true
      this.token = sessionStorage.getItem('token')

      this.newDevice = this.$route.params.newDevice === 'true'
      this.deviceId = this.$route.params.deviceId ? parseInt(this.$route.params.deviceId) : null
      this.siteId = this.$route.params.siteId ? parseInt(this.$route.params.siteId) : null

      if (
        this.$route.params.companyId &&
        this.$route.params.companyId !== null &&
        this.$route.params.companyId !== undefined &&
        this.$route.params.companyId !== '' &&
        !isNaN(parseInt(this.$route.params.companyId))
      ) {
        this.companyId = parseInt(this.$route.params.companyId)
      } else {
        this.companyId = null
      }

      await this.findDevicesModels()
      await this.findDevicesTypes()

      if (!this.newDevice && this.deviceId) {
        this.loadDeviceData()
        this.isAllowedDeviceEdit = false
      } else {
        this.isAllowedDeviceEdit = true
      }

      this.$nextTick(() => {
        this.deviceModel = this.getModel()
        if (!this.newDevice && this.deviceId) {
          this.updateModelFromSelected()
        }
      })
    } catch (error) {
      console.error('Erro no beforeMount:', error)
      await this.$alert('Erro ao carregar a página', 'Erro', 'error')
    } finally {
      this.isLoading = false
    }
  }
}
